// =============================================================================
// ENUMS
// =============================================================================

export enum SupportConversationStatus {
  OPEN = 'open',
  SNOOZED = 'snoozed',
  CLOSED = 'closed',
}

export enum SupportMessageType {
  TEXT = 'text',
  IMAGE = 'image',
  FILE = 'file',
  SYSTEM = 'system',
}

export enum SupportSenderType {
  CUSTOMER = 'customer',
  ADMIN = 'admin',
  SYSTEM = 'system',
}

// =============================================================================
// TYPES
// =============================================================================

export interface AttachmentItem {
  id: number;
  fileName: string;
  fileType: string;
  fileSize: number;
  url?: string;
  thumbnailUrl?: string;
}

export interface MessageItem {
  id: number;
  conversationId: number;
  senderType: SupportSenderType;
  senderId?: number;
  senderName: string;
  senderAvatarUrl?: string | null;
  content: string;
  messageType?: SupportMessageType;
  readAt: string | null;
  createdAt: string;
  attachments: AttachmentItem[];
}

export interface ConversationItem {
  id: number;
  status: SupportConversationStatus;
  subject: string | null;
  lastMessageAt: string;
  lastMessagePreview: string | null;
  unreadCount: number;
  assignedAdminId: number | null;
  assignedAdminUsername: string | null;
  assignedAdminAvatarUrl?: string | null;
  createdAt: string;
}

export interface ConversationDetail extends ConversationItem {
  messages: MessageItem[];
  assignedAdminDisplayName?: string | null;
  csatRequestedAt: string | null;
  csatRating: {
    rating: number;
    comment: string | null;
    createdAt: string;
  } | null;
}

export interface BusinessHoursStatus {
  isOpen: boolean;
  awayMessage: string | null;
  nextOpenTime: string | null;
}

// =============================================================================
// WEBSOCKET TYPES
// =============================================================================

export interface WsMessageEvent {
  message: MessageItem;
  conversationId: number;
}

export interface WsTypingEvent {
  conversationId: number;
  userId: number;
  userType: 'customer' | 'admin';
  userName: string;
  isTyping: boolean;
}

export interface WsCsatRequestEvent {
  conversationId: number;
}
